import { render, staticRenderFns } from "./BankAccountDetails.vue?vue&type=template&id=0ccff5f5&scoped=true&"
import script from "./BankAccountDetails.vue?vue&type=script&lang=ts&"
export * from "./BankAccountDetails.vue?vue&type=script&lang=ts&"
import style0 from "./BankAccountDetails.vue?vue&type=style&index=0&id=0ccff5f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccff5f5",
  null
  
)

export default component.exports